module.exports = __webpack_public_path__ + "img/bitkoin.3f69d048.svg";